var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 480H360C324.8 480 296 451.2 296 416V96C296 87.163 288.837 80 280 80H200C191.163 80 184 87.163 184 96V248C184 265.6 169.6 280 152 280H24C10.8 280 0 269.2 0 256V256C0 242.8 10.8 232 24 232H136V96C136 60.8 164.8 32 200 32H280C315.2 32 344 60.8 344 96V416C344 424.837 351.163 432 360 432H440C448.837 432 456 424.837 456 416V264C456 246.4 470.4 232 488 232H616C629.2 232 640 242.8 640 256V256C640 269.2 629.2 280 616 280H504V416C504 451.2 475.2 480 440 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSquare);
export default __webpack_public_path__ + "static/media/wave-square.f88af0141aedf88a3317e13a522fb426.svg";
export { ForwardRef as ReactComponent };